import './berryblue/style';
import FormStructure from './berryblue/form_structure';

export default FormStructure;